(function () {
  //Remove the view transition render blocker if the user has reduced motion enabled
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
  }

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    const finished = handleTransitionPromises(viewTransition);

    // Navigate normally from the search overlay. Its top-layer dialog and fixed
    // body can leave Chromium unable to animate the incoming product page.
    if (document.querySelector('#search-modal dialog[open]')) {
      sessionStorage.removeItem('custom-transition-type');
      viewTransition.skipTransition();
      return;
    }

    const controller = new AbortController();

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => viewTransition.skipTransition(),
        { once: true, signal: controller.signal }
      );
    });
    // A restored page must not keep listeners for an old transition.
    finished.then(() => controller.abort());

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    const finished = handleTransitionPromises(viewTransition);
    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      // Clean up even when the browser skips the animation (e.g. history navigation).
      sessionStorage.removeItem('custom-transition-type');
      document.querySelectorAll('[data-view-transition-type], [data-view-transition-triggered]').forEach((element) => {
        element.removeAttribute('data-view-transition-type');
        element.removeAttribute('data-view-transition-triggered');
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * Skipping a cross-document animation must not leave an unhandled rejection
   * or prevent cleanup. Navigation itself is still handled by the browser.
   * @param {ViewTransition} transition
   * @returns {Promise<void>}
   */
  function handleTransitionPromises(transition) {
    transition.ready.catch(handleTransitionError);
    return transition.finished.catch(handleTransitionError);
  }

  /** @param {unknown} error */
  function handleTransitionError(error) {
    if (error instanceof DOMException && ['AbortError', 'InvalidStateError', 'TimeoutError'].includes(error.name)) return;
    console.error('View transition failed:', error);
  }

  /**
   * Checks whether an Event object is carrying a `viewTransition` property
   * (as used by the View Transition API) and narrows the type accordingly.
   *
   * @template {Event} T
   * @param {T} event
   * @returns {event is T & { viewTransition: ViewTransition }}
   */
  function hasViewTransition(event) {
    return (
      typeof ViewTransition !== 'undefined' &&
      'viewTransition' in event &&
      event.viewTransition instanceof ViewTransition
    );
  }
})();
